import React from "react"
import { useNavigate } from "react-router-dom"
import { Button, Container, Row, Col } from "reactstrap"
// import { Wrench } from 'react-bootstrap-icons';

const UnderDevelopment = () => {
  const navigate = useNavigate()
  document.title = "Under Development"
  
  return (
    <div className="d-flex align-items-center min-vh-100 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col xl={8} lg={10} className="text-center">
            <div className="py-5">
              <div className="mb-4">
                <Wrench size={80} className="text-primary mb-3" />
              </div>
              <h1 className="display-4 font-weight-bold text-primary mb-3">
                Under Development1
              </h1>
              <p className="lead text-muted mb-4">
                We're working on something amazing!
              </p>
              <p className="text-muted mb-5">
                This page is currently under development. We're working hard to bring you 
                new features and improvements. Please check back soon!
              </p>
              <div className="d-flex gap-3 justify-content-center">
                <Button 
                  color="primary" 
                  className="px-4"
                  onClick={() => navigate(-1)}
                >
                  <i className="mdi mdi-arrow-left me-1"></i> Go Back
                </Button>
                <Button 
                  color="primary" 
                  outline 
                  className="px-4"
                  onClick={() => navigate("/", { replace: true })}
                >
                  <i className="mdi mdi-home me-1"></i> Back to Home
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default UnderDevelopment
